var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"stripe-credit-card"},[_c('div',{ref:"stripeCard",attrs:{"id":"stripe-card"}}),_c('div',{ref:"stripeCardErrors",staticClass:"caption error--text",attrs:{"id":"stripe-card-errors","role":"alert"}},[_vm._v(" "+_vm._s(_vm.stripeCardErrorLabel)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }